<template>
  <DataTable
    :items.sync="speciesSummary"
    :headers="headers"
    :propDense="true"
    :customCells="customCells"
    :hideHeader="true"
    :actions="[]"
  >
    <template #rate="{item}">
      {{ getRate(item) }}
    </template>
    <template #amount="{item}">
      {{ formatMoney(item.amount) }}
    </template>
    <template #body.append>
      <tr class="font-weight-bold">
        <td class="text-lg-left">Totals</td>
        <td class="text-right">-</td>
        <td class="text-right">{{ numberWithCommas(totals.totalnetMbf, 3) }}</td>
        <td class="text-right">{{ formatMoney(totals.totalAmount) }}</td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import { formatMoney, numberWithCommas } from '@/utils/NumericMutations'
import { tractProductionSpeciesHeaders } from '@/headers/Cycles.js'

export default {
  name: 'ProductSummaryTable',

  props: {
    speciesSummary: {
      type: Array,
      required: true
    }
  },

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue')
  },

  data: () => ({
    customCells: [
      {
        slotName: 'rate',
        value: 'rate'
      },
      {
        slotName: 'amount',
        value: 'amount'
      }
    ]
  }),

  computed: {
    headers () {
      return tractProductionSpeciesHeaders().getColumns()
    },

    totals () {
      const totals = {
        totalAmount: 0,
        totalnetMbf: 0
      }

      this.speciesSummary.forEach(ps => {
        totals.totalAmount += ps.amount
        totals.totalnetMbf += ps.netMbf
      })

      return totals
    }
  },

  methods: {
    formatMoney,
    numberWithCommas,
    getRate ({ amount, netMbf }) {
      return formatMoney((amount / netMbf))
    }
  }
}
</script>
